var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"auto"},attrs:{"id":"body"}},[_c('top'),_c('img',{staticStyle:{"object-fit":"fill"},attrs:{"src":require("../../../public/main.png"),"width":"100%","height":"100%"}}),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }